// React component that renders a circle or square with text inside of it

import React from 'react';

export interface TwIndicatorProps {
  /**
   * content of indicator
   **/
  content: string;
  /**
   * variant of indicator
   * */
  variant?: 'circle' | 'square';
  /**
   * color of indicator
   * */
  color?: string;
  /**
   * text color of indicator
   * */
  textColor?: string;
}

const TwIndicator: React.FC<TwIndicatorProps> = ({
  content,
  variant,
  color,
  textColor
}): JSX.Element => {
  return (
    <div
      style={{
        borderRadius: `${variant === 'circle' ? '50%' : '0'}`,
        width: '20px',
        height: '20px',
        fontSize: '14px',
        backgroundColor: `${color ? color : '#cbcbcb'}`,
        color: `${textColor ? textColor : '#fff'}`,
        textAlign: 'center'
      }}
    >
      {content}
    </div>
  );
};

export default TwIndicator;
